import axios from 'axios';
axios.defaults.withCredentials = true;
import qs from 'qs';
const couponTagExtParams = {
    SHUCU: '?types=4&fl=firstDestination,functionDisplay,taocanPrice,price,thumb,tagInfos,id,title,jumpInfo,validBatchIds,summary&filterTagValueType=sales,destination,shopCoupon&userCashBatch=20scdj99,20scdj10,20scdj5&shopAllianceCouponBatchIds=0000001592842476192Szk8,0000001592842388761ZV2n,00000015928423120813yUs'
};

export const getUdetail = (params)=> {
    return axios({
        url: '//oss.dujia.qunar.com/cg/udetail',
        method: 'GET',
        params
    });
};

export const getRecommend = (couponsArr, params)=> {
    return axios({
        url: '//oss.dujia.qunar.com/product/recommend',
        method: 'GET',
        params: {
            limit: '0,3',
            order: 'sales15-desc',
            removeSame: false,
            conditionJsonStr: JSON.stringify(couponsArr),
            ...params
        },
        paramsSerializer: (params)=> {
            return qs.stringify(params);
        }
    });
};

export const getRecommendFromTouch = (couponsArr, params)=> {
    return axios({
        url: '//touch.dujia.qunar.com/query/recommendByConfig',
        method: 'GET',
        params: {
            limit: '0,3',
            order: 'sales15-desc',
            removeSame: false,
            conditionJsonStr: JSON.stringify(couponsArr),
            ...params
        },
        paramsSerializer: (params)=> {
            return qs.stringify(params);
        }
    });
};

export const getDetail = (params, urlExtKey = '', urlExtStr = '')=> {
    return axios({
        url: '//oss.dujia.qunar.com/cg/detail' + urlExtStr + (urlExtKey ? (couponTagExtParams[urlExtKey] || '') : ''),
        method: 'GET',
        params: {
            ...params
        }
    });
};

export const getReceive = (params)=> {
    return axios({
        url: '//oss.dujia.qunar.com/cash/receive',
        params: {
            from: '20616',
            ...params
        }
    });
};

export const getDeps = (params)=> {
    return axios({
        url: '//oss.dujia.qunar.com/cg/udetail',
        method: 'GET',
        params: {
            ...params
        }
    });
};
